import assign from 'object-assign';
import zxcvbn from 'zxcvbn';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../../dispatcher/AdminAppDispatcher';
import AdminConstants from '../../constants/AdminConstants';
import {
  emailRegex,
  phoneRegex,
} from '../../utils/validation-regex';


const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'addDriverFormChanged';

const driverInitialState = {
  first_name: '',
  last_name: '',
  cdl_number: '',
  email: '',
  phone: '',
  password: '',
  confirmation: '',
};

const initialState = {
  error: {},
  submittable: false,
  isSuccess: false,
  show: false,
  driver: { ...driverInitialState },
};

let state = {
  ...initialState,
};

const good_example = 'correcthorsebatterystaple';
const AddDriverFormStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
  reset() {
    state = { ...initialState };
    this.emitChange();
  },
  onAddDriverSuccess() {
    state = {
      ...state,
      isSuccess: true,
      submittable: false,
      error: {},
      driver: { ...driverInitialState },
    };
    this.emitChange();
  },
  onAddDriverFail(error = {}) {
    let errorMessage;
    if (error.code === 11000) {
      errorMessage = 'EMAIL_OR_USERNAME_TAKEN';
    } else {
      errorMessage = 'PROBLEM_ADDING_DRIVER';
    }
    state = {
      ...state,
      error: {
        status: errorMessage,
      },
      isSuccess: false,
      submittable: false,
    };
    this.emitChange();
  },
  showForm() {
    state = {
      ...state,
      show: true,
    };
  },
  validate(driver = {}) {
    const {
      first_name,
      last_name,
      username,
      email,
      phone,
      password,
      confirmation,
      cdl_number,
    } = driver;
    const error = {};

    if (!first_name) {
      error.first_name = 'FIRST_NAME_REQUIRED';
    }

    if (!last_name) {
      error.last_name = 'LAST_NAME_REQUIRED';
    }

    if (!username) {
      error.username = 'USER_NAME_REQUIRED';
    }

    if (!phone) {
      error.phone = 'PHONE_NUMBER_REQUIRED';
    } else if (phone && !phoneRegex.test(phone)) {
      error.phone = 'PHONE_NUMBER_NOT_VALID';
    }

    if (email && !emailRegex.test(email)) {
      error.email = 'EMAIL_NOT_VALID';
    }

    if (!password) {
      error.password = 'PASSWORD_REQUIRED';
    } else if (password && password !== confirmation) {
      error.password = 'PASSWORD_DOES_NOT_MATCH';
    } else {
      const forbidden_words = ['cargomatic', good_example, phone, last_name, first_name, cdl_number, email];
      const complexityTest = zxcvbn(password, forbidden_words).score >= 1;

      if (!complexityTest) {
        error.password = 'PASSWORD_COMPLEXITY_NOTE';
      }
    }

    if (!cdl_number) {
      error.cdl_number = 'CDL_REQUIRED';
    }

    const submittable = Object.keys(error).length === 0;
    state = {
      ...state,
      error,
      submittable,
      driver,
    };
  },
  getFormState() {
    return state;
  },
});

AddDriverFormStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
  const { action } = payload;
  switch (action.type) {
    case ActionTypes.REQUEST_VALIDATE_NEW_DRIVER:
      AddDriverFormStore.validate(action.driver);
      AddDriverFormStore.emitChange();
      break;
    case ActionTypes.CREATE_DRIVER_SUCCESS:
      AddDriverFormStore.onAddDriverSuccess();
      AddDriverFormStore.emitChange();
      break;
    case ActionTypes.CREATE_DRIVER_FAIL:
      AddDriverFormStore.onAddDriverFail(action.error);
      AddDriverFormStore.emitChange();
      break;
    case ActionTypes.HIDE_ADD_DRIVER_FORM:
      AddDriverFormStore.reset();
      AddDriverFormStore.emitChange();
      break;
    case ActionTypes.SHOW_ADD_DRIVER_FORM:
      AddDriverFormStore.showForm();
      AddDriverFormStore.emitChange();
      break;
    default:
      break;
  }
});

module.exports = AddDriverFormStore;
